<template>
  <div class="">
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-tabs vertical light class="v-tabs-wrapper d-flex justify-end">
          <div class="tab-separator begin"></div>

          <v-tab to="/settings/order-cancellation-reasons">
            Order Cancellation Reasons
          </v-tab>
          <v-tab to="/settings/order-modify-reasons"
            >Order Modify Reasons</v-tab
          >
          <v-tab v-if="userType > 8" to="/settings/payment-types">
            Payment Types
          </v-tab>

          <div class="tab-separator end"></div>
        </v-tabs>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentTab: "",
    };
  },
  methods: {},
  watch: {},
  computed: {},
  created() {},
  components: {},
};
</script>

<style scoped>
>>> .v-slide-group__content.v-tabs-bar__content {
  height: 100vh;
}
</style>
